<template>
    <div id="coll">
        <Breadcrumb></Breadcrumb>
        <div class="form-body">
            <el-form :ref="form" :model="form" label-width="80px" style="padding: 0 5px">
                <el-form-item label="店铺名称">
                    <el-radio-group v-model="form.name" class="hide_input" @change="loadData">
                        <el-radio label="all">全部</el-radio>
                        <el-radio v-for="(item,index) in dpList" :label="item.shopId">{{item.shopName}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div style="border-top: 1px dashed #afafaf;padding-top: 5px;">
                    <el-form-item label="搜索类型">
                        <el-radio-group v-model="form.searchType" size="small" class="hide_input" @change="loadData">
                            <el-radio :label="1">标题</el-radio>
                            <el-radio :label="2">SKU</el-radio>
                            <el-radio :label="3">产品ID</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="搜索内容">
                        <el-input size="small" v-model="form.searchStr" style="width: 30%;border: 0px;" placeholder="请输入内容"></el-input>
                        <el-button size="small" type="primary" @click="search" style="margin-left: 10px">搜索</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div style="margin: 10px 0;display: inline-block;width: 100%">
            <div style="float: left">
                <el-dropdown trigger="click" @command="batchHandle">
                    <el-button type="primary" size="small">批量操作</el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">批量移入待发布</el-dropdown-item>
                        <el-dropdown-item command="2">批量删除</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <el-dropdown placement="bottom-start" trigger="click">
                    <el-button size="small" type="primary" style="margin-left: 10px">移动分类</el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-tree style="text-align: center;width: 180px"  :props="props"
                                 :load="loadNode" lazy
                                 @node-click="handleNodeClick"></el-tree>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div style="float: right">
                <!--<el-button size="small" type="primary">采集数据</el-button>-->
                <el-button size="small" type="primary"><router-link class="r_link" to="/product/lazada/createProduct">创建产品</router-link></el-button>
                <el-button size="small" type="primary">同步产品</el-button>
            </div>
        </div>
        <div class="lazada_coll_tab">
            <el-table id="outTable" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange"
                      :span-method="arraySpanMethod">
                <el-table-column type="selection" width="40" align="center"></el-table-column>

                <el-table-column prop="mainPic" label="图片" width="120" align="center">
                    <template scope="scope">
                        <el-popover placement="right" width="300" trigger="hover" :close-delay="closeDelay">
                            <div style="text-align: right;background-color: rgba(239,239,239,1);height: 25px;line-height: 25px">
                                <span style="padding-right: 20px;cursor: pointer;color: #4934b2" @click="searchProductSource(scope.row)">添加来源</span>
                            </div>
                            <img  class="img-big" :src="scope.row.mainPic" style="width: 300px;height: 300px"/>
                            <img slot="reference" class="img-small" :src="scope.row.mainPic"/>
                            <div slot="reference" style="font-size: 12px">来源：<a style="text-decoration: none;color: #4934b2" :href="scope.row.dataUrl" target="_blank">{{foramtDataSource(scope.row.dataSource)}}</a></div>
                        </el-popover>

                    </template>
                </el-table-column>


                <el-table-column prop="proTitle" label="标题/产品ID" width="300" align="left" header-align="center">
                    <template slot-scope="scope">
                        <el-row style="text-align: left">{{scope.row.proTitle}}</el-row>
                        <div style="margin-top: 10px;font-size: 12px;text-align: left">
                            <el-row style="color: #8a8a8a">店铺[{{scope.row.shopName}}]</el-row>
                            <el-row>备注:{{scope.row.remark}}</el-row>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="htmlCode"  label="SKU" align="center">
                    <template slot-scope="scope">
                        <div v-html="scope.row.htmlCode"></div>
                    </template>
                </el-table-column>
                <el-table-column label="价格" align="center"></el-table-column>
                <el-table-column label="促销价" align="center"></el-table-column>
                <el-table-column label="库存" align="center"></el-table-column>
                <el-table-column prop="createTime" label="时间" align="center" width="200">
                    <template slot-scope="scope">
                        <el-row class="left-12 color-999">创建:</el-row>
                        <el-row class="left-12">{{scope.row.createTime}}</el-row>
                        <el-row class="left-12 color-999">更新:</el-row>
                        <el-row class="left-12">{{scope.row.updateTime}}</el-row>
                    </template>
                </el-table-column>
                <el-table-column prop="handel" label="操作" align="center">
                    <template slot-scope="scope">
                        <div class="inner-tab-btn">
                            <div><el-button  type="text" size="mini" @click="move(scope.row)">移入待发布</el-button></div>
                            <div><el-button  type="text" size="mini" @click="edit(scope.row)">编辑</el-button></div>
                            <div><el-button  type="text" size="mini" @click="addRemark(scope.row)">添加备注</el-button></div>
                            <div><el-button  type="text" size="mini" @click="deleteRowById(scope.row)">删除</el-button></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
            </el-table>
            <pagination
                    v-show="total>0"
                    :total="total"
                    :page.sync="form.pageNum"
                    :limit.sync="form.pageSize"
                    @pagination="loadData"
            />
        </div>

        <!--添加备注-->
        <el-dialog :close-on-click-modal="false"   title="添加备注" width="35%" :visible.sync="noteDialogVisible" class="note-dialog">
            <el-row style="display: flex;align-items: center">
                <el-col :span="2">
                    <p>内容:</p>
                </el-col>
                <el-col :span="22">
                    <el-input v-model="noteContent"  placeholder="请输入介绍信息" type="textarea" :rows="10">

                    </el-input>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="noteDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="submitRemark" size="small">确 定</el-button>
            </div>
        </el-dialog>

        <!--添加来源-->
        <el-dialog :close-on-click-modal="false"   title="添加来源" width="500px" :visible.sync="sourceDialogVisible" class="lazada_addUrl_dialog">

               <div style="margin: 10px 20px 0">
                   <template v-for="(item,index) in currentUrls">
                       <el-input :key="'url_4_' + index" placeholder="请输入内容" v-model="item.url"
                                 onkeyup="this.value = this.value.replace(/[\,\，\s]/,'')"
                                 size="small" style="width:80%;margin:0 5px 5px 0;">
                           <template slot="prepend">{{index + 1}}</template>
                           <el-button slot="append" type="text" @click="goUrl(item.url)">访问</el-button>
                       </el-input>
                       <a :key="'a_1' +index" class="url_a" @click="addUrl"><i class="el-icon-plus" v-show="index == 0 && currentUrls.length < 5"></i></a>
                       <a :key="'a_2' +index" class="url_a" @click="deleteUrl(index)"><i class="el-icon-minus" v-if="index > 0"></i></a>
                   </template>
               </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="sourceDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="submitSource" size="small">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script type="text/ecmascript-6">
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {getDpList,getInnerDataList,moveToReady,bathMoveToReady,
        updateLazadaRemark,singledelete,batchdelete,getTreeList,batchMoveCatalog,
        updateLazadaDataUrl
    } from '@/api/product/lazada'
    import {handleTree} from '@/utils/jn'
    import store from '../../../store'
    export default {
        name: "CollectionBox",
        components:{Breadcrumb},
        data() {
            return {
                // 总条数
                total: 0,
                closeDelay:0,
                // 查询参数
                currentPage: 1,
                noteContent:'',
                currentUrls:[],
                form: {
                    pubStatus:'01',//采集箱状态
                    name:'all',
                    searchStr: null,
                    searchType: 1,
                    pageNum:1,
                    pageSize: 10
                },
                dpList: [],
                tableData: [],
                spanArr: [],
                innerTableData:[],
                innerData: [],
                props: {
                        id: 'id',
                        children: 'children',
                        label: 'typeNme'
                 },
                count: 1,
                treeData:[],
                noteDialogVisible:false,//备注弹框
                sourceDialogVisible:false,//添加来源
                ids:[], //选中的ID
                lazadaList:[], //批量对象
                lazadaList2:[], //批量对象
                updateStatePara:{},
                updateStatePara2:{},
                currentRow:null,
            }
        },
        created() {
            var that = this;
            getDpList().then(function(res){
                that.dpList =  res.data;
            }).catch(function(error){

            });
            this.loadData();
        },
        methods: {
            handleNodeClick(data,Node) {
                // 如果是顶级父节点
                if (Node.parent.level === 0) {
                    // 不会触发事件
                } else {
                    this.batchMoveCatalog(data);
                }
            },

            searchProductSource(row){
                this.currentUrls = [];
                this.currentRow = row;
                row.dataUrl.split(',').forEach(url =>{
                    this.currentUrls.push({url:url})
                });
                this.sourceDialogVisible=true;
            },

            addUrl:function(){
                this.currentUrls.push({url:''});
            },
            deleteUrl(index){
                this.currentUrls.splice(index,1);
            },
            submitSource(){
                let url = '\'';
                this.currentUrls.forEach((item,index) =>{
                    if(index < this.currentUrls.length-1){
                        url += item.url +',';
                    }else{
                        url += item.url +'\'';
                    }
                });
                let param={pId:this.currentRow.pId,dataUrl:url}
                updateLazadaDataUrl(param).then(res =>{
                    if(res.code == 200){
                        this.$message.success("修改成功！")
                    }
                });
            },

            goUrl(val){
                window.open(val, '_blank').location;
            },

            loadNode(node, resolve) {
                    var that =this;
                    if (node.level === 0) {
                        //查询顶级节点
                        let params = {};
                        getTreeList(params).then(function(res){
                            that.treeData = that.createTreeData(res.data);
                            return resolve(that.treeData);
                        }).catch(function(error){
                            this.$message.error(res.msg);
                        });
                    }else {
                        let params = {pTypeNo:node.data.id};
                        // 根据父节点id找寻下一级的所有节点
                        getTreeList(params).then(res => {
                            return resolve(res.data);
                        });
                    }

            },

            createTreeData(data){
                    let treedata = data.filter(father =>{
                        if(father['pTypeNo'] == ""||father['pTypeNo'] == null){
                            father['pTypeNo'] = '0'
                        }
                        let childArr = data.filter(child =>{
                            return  child['pTypeNo'] == father.id;
                        });
                        childArr.length > 0?father.children =childArr:'';
                        return father['pTypeNo'] == '0';
                    });
                    return treedata ;
                },

            loadData(){
                this.updateCurrentTime();
                var that =this;
                this.loading = true;
                    getInnerDataList(this.form).then(function(res){
                        that.tableData =  res.rows;
                        that.total = res.total;
                        that.loading = false;
                        for (let key in that.tableData) {
                            //SKU集合赋值
                            let innerData = that.tableData[key].lazadaSkus;
                            that.innerData= innerData;
                            that.Generationhtml(key);
                        }
                    }).catch(function(error){

                    });
                },

            //生成表格HTML
            Generationhtml(key){
                    // 控制单独的class
                    var className = key;
                    var tabHtml ='<table class="innerTab" style="width: 100%">'
                    this.innerData.forEach((item,index)=>{
                        //转空字符
                        if (item.skuno==null){
                        item.skuno='';
                    }
                    if (item.price==null){
                        item.price='';
                    }
                    if (item.promPrice==null){
                        item.promPrice='';
                    }
                    if (item.invent==null){
                        item.invent='';
                    }
                    if(index < 5){
                        tabHtml += `<tr>
                        <td >`+item.skuno +`</td>
                        <td >`+item.price +`</td>
                        <td >`+item.promPrice +`</td>
                        <td >`+item.invent +`</td>

                    </tr>`;
                    }else{
                        tabHtml += `<tr  style="display: none" class=${className}>
                        <td >`+item.skuno +`</td>
                        <td >`+item.price +`</td>
                        <td >`+item.promPrice +`</td>
                        <td >`+item.invent +`</td>
                    </tr>`;
                    }

                });
                    if(this.innerData.length > 5){
                        tabHtml += `</table><el-row class="tab_butt"><div id="row_bt" onclick="explanRow(${className})">展开<i class="el-icon-caret-bottom"></i></div></el-row>`;
                    }else{
                        tabHtml += `</table>`;
                    }
                    this.tableData[key].htmlCode = tabHtml;
                    window.explanRow = function (val) {
                        var flag = $("."+val).is(":hidden");
                        if(flag){
                            $("#row_bt").html(`收起<i class="el-icon-caret-top"></i>`);
                            $("."+val).show();
                        }else{
                            $("#row_bt").html(`展开<i class="el-icon-caret-bottom"></i>`);
                            $("."+val).hide();
                        }
                    }
                },

            setClassManage:function(){
                    this.classManageDialog = true;
                },
            closeCMDialog_f:function(){
                    this.classManageDialog = false;
                },
            show: function() {

            },
            search: function() {
                this.loadData();
            },
            batchHandle: function(val) {
                if ("1" == val) {
                    this.batchMoveToReady();
                } else {
                    this.batchDelete();
                }
            },
            foramtDataSource(val){
                if(val == '01'){
                    return "1688";
                }else if(val == '02'){
                    return "速卖通";
                }else if(val == '03'){
                    return "Lazada";
                } else if(val == '04'){
                    return "Amazon";
                } else if(val == '05'){
                    return "Shopee";
                }else if(val == '06'){
                    return "淘宝"
                }else if(val == "07"){
                    return "京东"
                }
                return "未知";
            },
            //批量移入待发布
            batchMoveToReady: function() {
                var that =this;
                const lazadaList = this.lazadaList;
                if (this.lazadaList.length==0){
                    this.msgError("批量待发布至少选择一条数据");
                    return;
                }
                this.$confirm('确定要将选中的商品移入待发布吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function() {
                    return bathMoveToReady(JSON.stringify(lazadaList));
                }).then(() => {
                    this.loadData();
                    this.$message({
                    type: 'success',
                    message:"批量移入成功"
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            //移入待发布
            move(row) {
                this.$confirm('确定要 [移入到待发布吗]?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function() {
                    return moveToReady(row.pId);
                }).then(() => {
                    this.loadData();
                this.$message({
                    type: 'success',
                    message: '移入成功!'
                });
            }).catch(() => {
                    this.$message({
                    type: 'info',
                    message: '已取消移入'
                });
            });
            },
            //批量删除
            batchDelete() {
                const ids =this.ids;
                this.$confirm('是否确认删除选择的' + this.ids.length + '条数据项?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return batchdelete(ids);
                }).then(() => {
                    this.loadData();
                this.msgSuccess("删除成功");
            }).catch(function() {});
            },

            //用户勾选
            handleSelectionChange(val) {
                var that = this;
                that.ids=[];
                that.lazadaList=[];
                that.lazadaList2=[];
                //获取当前用户
                var userName = this.$store.state.user.name;
                val.forEach((item) => {
                    //批量移入待发布
                    var updateStatePara={
                        "pId":item.pId,
                        "pubStatus":'02',
                        "operNo":userName
                    };
                this.ids.push(item.pId);
                this.lazadaList.push(updateStatePara);
                });

                val.forEach((item) => {
                    //批量移入待发布
                    var updateStatePara2 = {
                        "pId": item.pId,
                        "pubStatus": '01',
                        "operNo": userName,
                        "typeNo": ""
                    };
                    this.lazadaList2.push(updateStatePara2);
                });


            },
            //合并列
            arraySpanMethod: function({row,column,rowIndex,columnIndex}) {
                if (columnIndex === 3) {
                    return [1, 4];
                }else if(columnIndex === 4 || columnIndex === 5 ||columnIndex === 6){
                    //将合并后的第四、五、六列单元格清除掉，不然后面的单元格会后移
                    return [0, 0];
                }
            },
            getSpanArr(data) {
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同,因合并第一个所以[0]
                        if (data[i]["id"] === data[i - 1]["id"]) {
                            this.spanArr[this.pos] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.pos = i;
                        }
                    }
                }
            },
            handleSizeChange: function(val) {
                console.log(`每页: ${val}条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            },

            edit: function(row) {
                //编辑产品
                this.$router.push({path:"/product/lazada/edit",query:{pId:row.pId}})
            },
            //添加备注方法
            addRemark:function(row){
                var that =this;
               /* for (let key in that.form) {
                    that.form[key]=null;
                }*/
                that.noteDialogVisible=true;
                that.form.remark =row.remark;
                that.noteContent =row.remark;
                that.form.pId=row.pId;
            },
            //提交备注
            submitRemark(remark){
                console.log(this.form);
                this.form.remark =this.noteContent;
                updateLazadaRemark(this.form).then((res) => {
                    if (res.code === 200) {
                    this.msgSuccess("添加成功");
                    this.loadData();
                    this.noteDialogVisible = false;
                }
            })
            },

            moveToReady(){
                var that =this;
                this.loading = true;
                moveToReadyByRowId(this.form).then(function(res){

                }).catch(function(error){

                });
            },

            deleteRowById:function(row) {
                console.log(row);
                let params ={"pId":row.pId,"shopId":row.shopId}
                this.$confirm('是否确认删除Lazada产品标题为'+row.proTitle+'的数据项?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return singledelete(params);
                }).then(() => {
                    this.loadData();
                    this.msgSuccess("删除成功");
            }).catch(function() {

                });
            },
            batchMoveCatalog: function(data) {
                let that =this;
                if (that.lazadaList2.length=='0'){
                    this.msgError("至少选择一条数据!");
                    return;
                }else if(data.isPar=='1') {
                    this.msgError("该节点不支持分类!");
                    return;
                }
                that.lazadaList2.forEach((item) => {
                    item.typeNo=data.typeNo;
                });
                console.log("============lazadaList2=================");
                console.log(that.lazadaList2);
                this.$confirm('确定要将选中的商品移入到该类别吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function() {
                   return batchMoveCatalog(JSON.stringify(that.lazadaList2));
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '移入成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            //修改stroe中的currentTime
            updateCurrentTime(){
                store.dispatch('setCurrentTime',new Date())
            }

        },
        mounted() {
            this.getSpanArr(this.tableData);
        },




    }
</script>

<style scoped>

</style>
